// AI Generated Component
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { FormUtils } from '@client/ng2/shared/form-utils';
import { NgForm } from '@angular/forms';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule-count-rule',
    templateUrl: './count-rule.component.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleCountRuleComponent implements OnInit, AfterViewInit {
    @Input() cRule: any;
    @Input() monDialogId: any;
    @ViewChild('policyRuleForm') policyRuleForm?: NgForm;

    areAllSubEntriesSelected = false;
    label: string = '';
    CharacterLabel: string = '';
    typeOptions: any[] = [];
    dropdownOptions: any[] = [];
    subEntry: any;
    selectedOption: any;

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private monDialog: MonDialog,
        private translateService: TranslateService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setFocus(this.monDialogId, this.policyRuleForm);
    }

    activate (): void {
        this.areAllSubEntriesSelected = false;
        this.policyFormHelperService.setRuleType(this.cRule.type);
        this.setupTypeOptions();
        this.setupRuleSubEntries();
        this.setupLabelQueryText();
        const parsedValue = parseInt(this.cRule.query);
        if (!isNaN(parsedValue)) {
            this.cRule.query = parsedValue;
        }
        if (!this.cRule.name) {
            this.chooseOperator(this.typeOptions.length > 0 ? this.typeOptions[0] : {});
        } else {
            this.chooseOperator(
                this.typeOptions.find((type: any) => {
                    return type.type === this.cRule.operator;
                }),
            );
        }
    }

    setupLabelQueryText (): void {
        let label: string = '';
        this.label = this.translateService.getString('Characters');
        switch (this.cRule.type) {
            case 'external_link_count':
                label = this.translateService.getString('Number of external links');
                this.label = this.translateService.getString('Links');
                break;
            case 'incoming_link_count':
                label = this.translateService.getString('Number of incoming links');
                this.label = this.translateService.getString('Links');
                break;
            case 'page_title_length':
                label = this.translateService.getString('Number of characters in page title');
                break;
            case 'link_text_length':
                label = this.translateService.getString('Number of characters in link text');
                break;
            case 'image_text_length':
                label = this.translateService.getString('Number of characters in image text');
                break;
            case 'header_text_length':
                label = this.translateService.getString('Number of characters in header text');
                break;
        }

        this.CharacterLabel = label;
    }

    setupTypeOptions (): void {
        this.typeOptions = this.policyFormHelperService.getOptionsByRuleType();
        this.dropdownOptions = this.typeOptions.map((option: any) => {
            return {
                ...option,
                action: () => this.chooseType(option),
                label: option.translation,
            };
        });
    }

    setupRuleSubEntries (): void {
        this.subEntry = this.policyFormHelperService.getRuleSubEntries();
        this.checkSelectedSubEntries();
    }

    chooseOperator (option: any): void {
        this.selectedOption = option;
        this.cRule.operator = option.type;
    }

    chooseType (option: any): void {
        this.chooseOperator(option);
    }

    selectAllSubEntries (): void {
        if (this.cRule.sub_entry.length === this.subEntry.options.length) {
            this.cRule.sub_entry = [];
            this.areAllSubEntriesSelected = false;
        } else {
            this.cRule.sub_entry = this.subEntry.options.map((entry: any) => {
                return entry.value;
            });
            this.areAllSubEntriesSelected = true;
        }
    }

    checkSelectedSubEntries (): void {
        this.areAllSubEntriesSelected =
            this.subEntry.options.length > 0 && this.subEntry.options.length === this.cRule.sub_entry.length;
    }

    close (): void {
        const newRule = safeClone(this.cRule);
        newRule.sub_entry = newRule.sub_entry.join(',');
        newRule.query = newRule.query === '' ? 0 : newRule.query;
        FormUtils.markFormAsPristine(this.policyRuleForm);
        this.monDialog.close(this.monDialogId, newRule);
    }
}
